/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React from 'react';

import { Colors } from 'src/common/ui/base';
import { Nav, NAV_HEIGHT } from 'src/components/app/Nav/Nav';
import Body from 'src/components/app/body';

export const Content = () => (
  <div
    css={css`
      display: flex;
      flex-grow: 1;
      min-height: 100%;
      min-width: 710px;
      position: relative;
      z-index: 1;
    `}
  >
    <Nav />

    <div
      css={css`
        flex-grow: 1;
        background-color: ${Colors.CoolGray1};
        min-width: 0; // So the Typography noWrap works
        min-height: 100vh;
        padding-top: ${NAV_HEIGHT}px;
      `}
    >
      <Body />
    </div>
  </div>
);
